import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Alert, Button } from '@mui/material';
import { supabase } from '../../../lib/supabase';
import ReactMarkdown from 'react-markdown';

const SuccessStoryDetailPage = () => {
  const { storyId } = useParams();
  const navigate = useNavigate();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStory = async () => {
      setLoading(true);
      setError(null);
      // 콘솔로 storyId 확인
      console.log('storyId:', storyId);
      const { data, error } = await supabase
        .from('success_stories')
        .select('*')
        .eq('id', storyId)
        .single();
      if (error) setError('합격 스토리를 불러오는 중 오류가 발생했습니다.');
      setStory(data);
      setLoading(false);
      // 콘솔로 데이터 확인
      console.log('story:', data, 'error:', error);
    };
    fetchStory();
  }, [storyId]);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 300 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error || !story) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error">{error || '합격 스토리를 찾을 수 없습니다.'}</Alert>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>목록으로</Button>
      </Container>
    );
  }

  function getYoutubeEmbedUrl(url) {
    const match = url && url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  }

  const youtubeUrl = story.youtube_url;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>{story.title}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        시험일: {story.exam_date} | 점수: {story.exam_score} | 공부기간: {story.study_period} | 상태: {story.state}
      </Typography>
      <div dangerouslySetInnerHTML={{ __html: story.content }} />
      {youtubeUrl && getYoutubeEmbedUrl(youtubeUrl) && (
        <Box sx={{ mb: 4 }}>
          <iframe
            width="100%"
            height="315"
            src={getYoutubeEmbedUrl(youtubeUrl)}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      )}
      <Button onClick={() => navigate(-1)}>목록으로</Button>
    </Container>
  );
};

export default SuccessStoryDetailPage;
